import React from 'react'

function Passback({ pass }) {
  const yourDetails = {
    key: 'your_details',
    label: 'Your details',
    value: `${pass.userId.fullName}
${pass.userId.email}`,
    readOnly: true,
  }

  // Defaults for passes whose design has no saved back fields yet
  const systemFields = [
    yourDetails,
    {
      key: 'issuer_info',
      label: 'Issuer information',
      value: `Email: ${pass.userId.email}
Company: ${pass.accountId.organisationName}
Phone: ${pass.accountId.phoneNumber || pass.userId.phone}`,
    },
    {
      key: 'terms',
      label: 'Terms of use',
      value: `1. Redeem your loyalty card to get a points on your every visit.
2. Loyalty card expiration date is unlimited.
3. Loyalty cards cannot be exchanged, returned, replaced or purchased for cash.
4. Loyalty card cannot be returned to the issuer and cannot be combined with other cards.
5. The company has the right to refuse to provide services.`,
    },
    {
      key: 'powered_by',
      value: `POWERED BY LoyalIdeas`,
      readOnly: true,
    },
  ]

  // Render the design's saved back fields, in the same order the wallet pass
  // uses. The editor stores the merchant's details under your_details, so
  // that one is swapped for the cardholder's own details.
  const designFields = (pass.designId?.backFields || [])
    .map((field) => (field.key === 'your_details' ? yourDetails : field))
    .filter((field) => field.value && field.value.trim())

  const backFields = designFields.length ? designFields : systemFields

  return (
    <>
      {/* Top Pass Card */}
      <div className="tw-mt-3 tw-w-full sm:tw-w-52 tw-mx-auto">
        <div className="tw-border-b tw-px-1.5">
          <div
            className="tw-shadow"
            style={{ backgroundColor: pass.designId?.backgroundColor }}
          >
            <div className="tw-flex tw-flex-col sm:tw-flex-row tw-justify-between tw-items-start tw-p-1 tw-gap-2">
              <div className="tw-flex tw-items-center tw-truncate">
                <img
                  className="tw-w-6 tw-h-6 sm:tw-w-3 sm:tw-h-3"
                  src={pass.designId?.logoImage || 'https://placehold.co/600x600'}
                  alt="logo"
                />
                <div />
              </div>
            </div>

            <div className="">
              <img
                className="tw-w-full tw-object-cover tw-max-h-28 sm:tw-max-h-12"
                src={pass.designId?.stripImage || 'https://placehold.co/600x600'}
                alt="cover"
              />
            </div>

            <div className="tw-flex tw-flex-col sm:tw-flex-row tw-justify-between tw-items-start tw-p-1 tw-gap-2">
              <div>
                <h1 className="tw-font-medium tw-text-xs sm:tw-text-[4px]">
                  Customer Name
                </h1>
                <h1 className="tw-font-light tw-text-xs sm:tw-text-[6px]">
                  {pass.userId?.fullName}
                </h1>
              </div>
              <div className="tw-text-right">
                <h1 className="tw-font-medium tw-text-xs sm:tw-text-[4px]">Points</h1>
                <h1 className="tw-font-light tw-text-xs sm:tw-text-[6px]">
                  {pass.ponit_balance}
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div className="tw-text-center">
          <div className="tw-font-bold tw-mt-3.5">{pass.accountId?.organisationName}</div>
          <div className="tw-font-light tw-text-xs tw-text-gray-500">updated 4 days ago</div>
        </div>
      </div>

      {/* System Fields Section */}
      <div className="tw-mt-4 tw-bg-white tw-border tw-shadow-md tw-rounded-lg tw-px-2 tw-py-3 tw-mb-6 tw-w-full sm:tw-w-1/2 md:tw-w-1/4 tw-mx-auto">
        {backFields.map((field, index) => (
          <React.Fragment key={field.key}>
            {field.label && (
              <div className="tw-text-sm tw-mt-5 tw-mb-2" style={{ fontWeight: 'bold' }}>
                {field.label}
              </div>
            )}
            <div
              dangerouslySetInnerHTML={{ __html: field.value }}
              className="tw-text-sm tw-mb-2 tw-whitespace-pre-line"
            />
            {index < backFields.length - 1 && <hr />}
          </React.Fragment>
        ))}
        {/* Original comments preserved */}
        {/* <div className="tw-text-sm tw-mt-5 tw-mb-2" style={{ fontWeight: 'bold' }}>
            Your Details:
          </div>
          ... */}
      </div>
    </>
  )
}

export default Passback
